import r from "../../managers/braze-instance.js";
import { destroyFeedHtml as ee } from "../../common/feed-display.js";
export function destroyFeed() {
  if (!r.rr()) return;
  const e = document.querySelectorAll(".ab-feed");
  for (let o = 0; o < e.length; o++) ee(e[o]);
}
